/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentRunQuestionRequest {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentRunQuestionRequest.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentRunQuestionRequest>): WellArchitectedFrameworkAssessmentRunQuestionRequest {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentRunQuestionRequest(), model);
        WellArchitectedFrameworkAssessmentRunQuestionRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentRunQuestionRequest>): WellArchitectedFrameworkAssessmentRunQuestionRequest {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentRunQuestionRequest.newInstance(<WellArchitectedFrameworkAssessmentRunQuestionRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentRunQuestionRequest) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentRunQuestionRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentRunQuestionRequest): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentRunQuestionRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.assessment_run_history_ids) {
            for (let val of this.assessment_run_history_ids) {
                models.RecordIdentity.fixupPrototype(val);
            }
        }
    }

    assessment_run_history_ids: Array<models.RecordIdentity>;

}
